module.exports = __webpack_public_path__ + "img/figure-13.559d4c31.png";